module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/tabination/tab-group/tab-group.component.scss
// module id = ./src/app/features/tabination/tab-group/tab-group.component.scss
// module chunks = main